import { useLocalSearchParams } from 'expo-router';
import { SettingsScreen } from '../../src/features/settings';

export default function SettingsRoute() {
  const { section, checkout } = useLocalSearchParams<{ section?: string; checkout?: string }>();
  const checkoutReturn = checkout === 'return' || checkout === 'cancel' ? checkout : undefined;
  return (
    <SettingsScreen
      initialSection={section === 'billing' ? 'billing' : undefined}
      checkoutReturn={checkoutReturn}
    />
  );
}
